/**
 * Resolves where `/` should send the visitor based on FitX session cookies.
 * Priority matches historical additional-routes.js order: admin → trainer → client → guest.
 *
 * @param {{ adminSignedIn?: boolean, trainerSignedIn?: boolean, clientSignedIn?: boolean }} flags
 * @returns {{ path: string } | { name: string }}
 */
export function resolveRootRedirect({
  adminSignedIn = false,
  trainerSignedIn = false,
  clientSignedIn = false,
} = {}) {
  if (adminSignedIn)
    return { path: '/admin' }

  if (trainerSignedIn)
    return { name: 'dashboard' }

  if (clientSignedIn)
    return { path: '/client/today' }

  return { name: 'landing' }
}
